import { render, staticRenderFns } from "./businessAnalysis-info.vue?vue&type=template&id=5d50485c&scoped=true&"
import script from "./businessAnalysis-info.vue?vue&type=script&lang=js&"
export * from "./businessAnalysis-info.vue?vue&type=script&lang=js&"
import style0 from "./businessAnalysis-info.vue?vue&type=style&index=0&id=5d50485c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50485c",
  null
  
)

export default component.exports